<template>
  <div class="rails-content" :class="{ 'is-medium': isMedium }">
    <div
      class="rails-content__background"
      data-in-out
      data-in-out-animation="fade"
      data-in-out-no-menu
    ></div>
    <div
      class="rail__wrapper desktop"
      data-in-out
      data-in-out-animation="rail-left"
      data-in-delay="0.2"
    >
      <div class="rail rail--left" ref="left">
        <RailPicture v-for="(article, index) in odds" :key="index" :data="article" :is-medium="isMedium" />
      </div>
    </div>
    <div
      class="rail__wrapper desktop"
      data-in-out
      data-in-out-animation="rail-right"
      data-in-delay="0.3"
    >
      <div class="rail rail--right" ref="right">
        <RailPicture v-for="(article, index) in even" :key="index" :data="article" :is-medium="isMedium" />
      </div>
    </div>

    <div class="rail__wrapper mobile" data-in-out data-in-out-animation="rail-right" ref="mobile">
      <div class="rail rail--mobile">
        <RailPicture v-for="(article, index) in data" :key="index" :data="article" :is-medium="isMedium" />
      </div>

      <MobileFooter />
    </div>
  </div>
</template>

<script>
import scroll from '@/scripts/scroll';
import engine from '@/scripts/engine';
import RailPicture from '@/components/contents/RailPicture.vue';
import MobileFooter from '@/components/MobileFooter.vue';
import { isMobile } from '@/scripts/utils';

export default {
  name: 'RailsContent',

  components: {
    RailPicture,
    MobileFooter,
  },

  props: ['data', 'isMedium'],

  watch: {
    data(newData) {
      if (newData) {
        if (!isMobile()) this.$nextTick(() => scroll.setBoundries(this.$refs.right, window.innerHeight));
        else this.$nextTick(() => scroll.setBoundries(this.$refs.mobile, window.innerHeight));
      }
    },
  },

  computed: {
    odds() {
      let odds = [];
      this.data.forEach((article, index) => index % 2 !== 0 && odds.push(article));
      if (this.data.length === 0) odds = [{ placeholder: true }];
      return odds;
    },
    even() {
      let even = [];
      this.data.forEach((article, index) => index % 2 === 0 && even.push(article));
      if (this.data.length === 0) even = [{ placeholder: true }];
      return even;
    },
  },

  mounted() {
    engine.add(this.scroll, 'rails-scroll', true);
  },

  methods: {
    scroll() {
      scroll.checkIsScrolled(200);
      this.$refs.left.style.transform = `translateY(calc(((100vh / 18) * 9) - ${scroll.ref.amount.y}px))`;
      this.$refs.right.style.transform = `translateY(calc(-100% + ((100vh / 18) * 9) + ${scroll.ref.amount.y}px))`;
      this.$refs.mobile.style.transform = `translateY(-${scroll.ref.amount.y}px)`;
    },
  },

  beforeDestroy() {
    engine.remove('rails-scroll');
    this.$store.commit('SET_PAGE_SCROLLED', false);
  },
};
</script>

<style lang="scss" scoped>
.rails-content {
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  @include mq($until: ipadL) {
    padding-top: calc((100vh / 18) * 14);
  }

  &__background {
    @extend %full;
    background-color: $color-white;
  }

  .rail__wrapper {
    &.desktop {
      display: block;

      @include mq($until: ipadL) {
        display: none;
      }

      .rail {
        position: absolute;
        top: 0px;
        width: calc((100vw / 32) * 9);

        @include mq($until: ds) {
          width: calc((100vw / 32) * 10);
        }

        &--left {
          left: calc((100vw / 32) * 7);

          @include mq($until: ds) {
            left: calc((100vw / 32) * 4);
          }
        }

        &--right {
          right: calc((100vw / 32) * 4);
        }
      }
    }

    &.mobile {
      display: none;

      @include mq($until: ipadL) {
        display: block;
      }

      .rail {
        position: relative;
        width: calc(100% - ((100vw / 32) * 8));
        left: calc((100vw / 32) * 4);
      }
    }
  }
}
</style>
